import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import "../../App.css";
import { GET_ADJUST_OUT_REPORT } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

const adjustOutReason = (value) => {
  if (value === "lose") {
    return "បាត់";
  } else if (value === "broken") {
    return "ខូច";
  } else if (value === "to_use") {
    return "ប្រើប្រាស់";
  } else if (value === "excess") {
    return "លើស";
  } else {
    return value;
  }
};

export default function ReportAdjustOut({
  startDate,
  endDate,
  meterialId,
  warehouseValId,
  reason,
}) {
  //
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  useQuery(GET_ADJUST_OUT_REPORT, {
    variables: {
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: meterialId ? meterialId : [],
      listMaterialUnitIds: [],
      from: startDate ? dayjs(startDate)?.format("YYYY-MM-DD") : "",
      to: endDate ? dayjs(endDate)?.format("YYYY-MM-DD") : "",
      reasons: reason === "all" ? [] : [reason],
    },
    onCompleted: ({ getAdjustOutReport }) => {
      // console.log("getAdjustOutReport:::", getAdjustOutReport);
      setTableData(getAdjustOutReport);

      if (getAdjustOutReport?.length > 0) {
        let total = 0;
        getAdjustOutReport?.forEach((row) => {
          total += row?.qty * row?.unitPrice;
        });
        setTotalAmount(total);
      } else setTotalAmount(0);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::getAdjustOutReport", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
  }, [startDate, endDate, meterialId, warehouseValId, reason]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">
          របាយការណ៍កែប្រែទំនិញចេញឃ្លាំង
        </Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>

      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody>
            <tr>
              <td className="report-table-th-sticky" align="center" width="2%">
                ល.រ
              </td>
              <td className="report-table-th-sticky" align="center">
                កាលបរិច្ឆេទ
              </td>
              <td className="report-table-th-sticky" align="center">
                ឃ្លាំង
              </td>
              <td className="report-table-th-sticky" align="center">
                បរិយាយ
              </td>
              <td className="report-table-th-sticky" align="center">
                មូលហេតុ
              </td>
              <td className="report-table-th-sticky" align="center">
                ខ្នាត
              </td>
              <td className="report-table-th-sticky" align="center">
                ចំនួន
              </td>
            </tr>
          </tbody>

          <tbody className="report-table-body">
            {loading ? (
              <LoadingTr colSpan={7} />
            ) : !tableData?.length ? (
              <EmptyTr colSpan={7} />
            ) : (
              tableData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td className="report-table-body-td-center">{index + 1}</td>

                    <td className="report-table-body-td-center">
                      {moment(row?.createdAt)?.format("DD-MM-YYYY hh:mm a")}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.adjustOutId?.warehouseId?.warehouseName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </td>

                    <td className="report-table-body-td-center">
                      {adjustOutReason(row?.adjustOutId?.reason)}
                    </td>

                    <td className="report-table-body-td-center" width="5%">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </td>

                    <td className="report-table-body-td-center" width="5%">
                      {row?.qty}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
